/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    covITProfessionals: {
        id: 'quoteandbind.PPLProLinedirectives.templates.MedicalPractitioners.Coverages',
        defaultMessage: 'Coverages'
    },
    formITProfessionals:{
        id: 'quoteandbind.PPLProLinedirectives.templates.MedicalPractitioners.Endorsements',
        defaultMessage: 'Endorsements'
    },
    totRevClaA6Msg:{
        id: 'quoteandbind.PPLProLinedirectives.templates.MedicalPractitioners.Total Revenue - Class A (%) must be between 0 and 100',
        defaultMessage: 'Total Revenue - Class A (%) must be between 0 and 100'
    },
    totRevClaB7Msg:{
        id: 'quoteandbind.PPLProLinedirectives.templates.MedicalPractitioners.Total Revenue - Class B (%) must be between 0 and 100',
        defaultMessage: 'Total Revenue - Class B (%) must be between 0 and 100'
    },
    totRevClaC8MsgMsg:{
        id: 'quoteandbind.PPLProLinedirectives.templates.MedicalPractitioners.Total Revenue - Class C (%) must be between 0 and 100',
        defaultMessage: 'Total Revenue - Class C (%) must be between 0 and 100'
    },
    totRevForAllCla9Msg:{
        id: 'quoteandbind.PPLProLinedirectives.templates.MedicalPractitioners.Total Revenue % for all Classes must be between 0 and 100',
        defaultMessage: 'Total Revenue % for all Classes must be between 0 and 100'
    },
    totRevForSerRelToAlt10Msg:{
        id: 'quoteandbind.PPLProLinedirectives.templates.MedicalPractitioners.Total Revenue % for services relating to alternative therapists must be between 0 and 100',
        defaultMessage: 'Total Revenue % for services relating to alternative therapists must be between 0 and 100'
    },
    totRevForSerRelToHea11Msg:{
        id: 'quoteandbind.PPLProLinedirectives.templates.MedicalPractitioners.Total Revenue % for services relating to health care clinics and facilities must be between 0 and 100',
        defaultMessage: 'Total Revenue % for services relating to health care clinics and facilities must be between 0 and 100'
    }
});
